import React, { useCallback } from 'react';
import { useMatch } from 'react-router-dom';

import { BaseProps } from '@make-software/cspr-design';

import { useCustomHistory } from '../../router/utils';

/* eslint-disable-next-line */
export interface RouterLinkProps extends BaseProps {
  to: string;
  exact?: boolean;
  allowedGoBack?: boolean;
  render?: (props: {
    onClick: () => void;
    active: boolean;
  }) => React.ReactElement;
}

export function RouterLink({
  to,
  allowedGoBack,
  render,
  children,
}: RouterLinkProps) {
  const match = useMatch(to);

  const history = useCustomHistory();
  const onClickHandler = useCallback(() => {
    history.push(to, {
      allowedGoBack: allowedGoBack,
    });
  }, [history, to]);

  if (render) {
    return render({ onClick: onClickHandler, active: !!match });
  }

  return children;
}

export default RouterLink;
